import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import CompetitorMetrics from "./CompetitorMetrics";
import PageSpeedMetrics from "./PageSpeedMetrics";
import EngagementMetrics from "./EngagementMetrics";
import { useSelector } from "react-redux";
import { Stack } from "@mui/system";
import { Skeleton } from "@mui/material";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  boxShadow: `0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.2)`,
  borderRadius: `4px`,
  overflow: `hidden`,
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "#ffffff",
  flexDirection: "row",
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(180deg)",
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const LandingPageMetrics = () => {
  const { pageSpeedMetricsLoading } = useSelector(
    (state: any) => state.landingPageExperience
  );
  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Competitor Metrics</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CompetitorMetrics />
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ my: "10px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">Page Speed Metrics</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {pageSpeedMetricsLoading ? (
            <Stack spacing={2}>
              {[...Array(5)].map((_, idx) => (
                <Skeleton key={idx} variant="rectangular" height={30} />
              ))}
            </Stack>
          ) : (
            <PageSpeedMetrics />
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <Typography component="span">Engagement Metrics</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <EngagementMetrics />
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default LandingPageMetrics;
